import React from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'rsuite';
import DocumentUpload from '../../../Shared/Upload/DocumentUpload';

function BulkCourseUpload(props) {

    return (

        <Card>
            <Card.Header>
                <h6>Record Uploads (Logs and Certificates)</h6>
            </Card.Header>
            <Card.Body>
                <p>
                    <h5 style={{ color: "black" }}>Use if:</h5>
                    <ul>
                        <li>
                            You have Adobe Acrobat or some type of PDF combining software
                        </li>
                        <li>
                            You have working knowledge of ZIP files
                        </li>
                    </ul>
                </p>
                <p>
                    <h5 style={{ color: "black" }}>Instructions: Uploading Certificates in ONE PDF FILE or ONE ZIP FILE:</h5>
                    <ul>
                        <li>
                            <b>Complete Your CPD Hours</b>
                            <ul>
                                <li>Make sure you have enough CPD hours for the <b>past two calendar years</b>.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Download the CPD Log Form</b>
                            <ul>
                                <li>Download the form from the LAPELS <a href="https://www.lapels.com/docs/CPD/CPD_Log_v2.pdf" target="_blank">website</a>. You'll need <b>one log for each calendar year</b>.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Complete Logs</b>
                            <ul>
                                <li>Enter your CPD activities on each year's log.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Gather Your Certificates</b>
                            <ul>
                                <li>Collect the <b>certificates for each course/activity</b> listed on your logs.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Organize and Combine into One File</b>
                            <ul>
                                <li>
                                    <b>PDF:</b>
                                    <ol>
                                        <li>Put the <b>log(s)</b> first, followed by the <b>matching certificate(s)</b>.</li>
                                        <li>Put everything in <b>one PDF file</b>, in that exact order.</li>
                                    </ol>
                                </li>
                                <li>
                                    <b>ZIP:</b>
                                    <ol>
                                        <li>Put the <b>log(s)</b> first, followed by the <b>matching certificate(s)</b>.</li>
                                        <li>Put everything to <b>one ZIP file</b>, numbered in the same order as appears on the log files.</li>
                                    </ol>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <b>Upload the PDF/ZIP File below ("Click or Drag files to this area to upload")</b>
                        </li>
                    </ul>
                </p>
                <Form>
                    <DocumentUpload
                        isUserEditable={true}
                        attachmentSection={"Cpd"}
                        parentId={props.entityId}
                        parentTypeId={11}
                        entityId={props.entityId}
                        fileUploadTitle={" "}
                        allowLegacy={true}
                    />
                </Form>
            </Card.Body>
        </Card>
    )
}

export default BulkCourseUpload;